import { Component, OnInit,Input,AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { CommonUtil } from '../Utils/common-util';

@Component({
  selector: 'app-halo-custom-loader',
  templateUrl: './halo-custom-loader.component.html',
  styleUrls: ['./halo-custom-loader.component.scss'],
})

export class HaloCustomLoaderComponent implements OnInit {
  @Input() customLoaderIsLoading = false;
  @Input() customLoaderErrorMsg:string;
  @Input() customLoaderRedirectButtonLabel:string;
  @Input() customLoaderRedirectButtonUrl:string;
  @ViewChild('spinnerElementRef', { static: false }) spinnerElementRef: ElementRef;
  constructor(public commonUtil: CommonUtil) {}
  ngOnInit() {
  }

  ngAfterViewInit(){
    this.setSpinnerPosition();
  }
  
  setSpinnerPosition(){
    let parentElement = <HTMLElement>this.spinnerElementRef.nativeElement.parentElement?.parentElement;
    parentElement.style.position = "relative";
  }

  onRedirectButtonClick(){
    window.location.href = this.customLoaderRedirectButtonUrl;
  }

}
